import { useTheme } from 'next-themes';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      position='top-center'
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: 'flex items-center gap-2 p-5 rounded-lg shadow-lg',
          error: 'bg-declined text-white',
          success: 'bg-completed text-white',
          warning: 'bg-inReview text-white',
          info: 'bg-newClaim text-white',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
